export default __webpack_public_path__ + "static/media/Light.538ab4bc.svg";